module.exports = __webpack_public_path__ + "img/reward.1ac7ae34.svg";